import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';

import { OnboardingTriggerBus } from './onboarding-trigger-bus.service';

const READ_METHODS = new Set(['GET', 'HEAD', 'OPTIONS']);

/**
 * Detecta a conclusão efetiva de operações reais (resposta 2xx de uma escrita que casa com um
 * gatilho declarado na jornada) e pede uma nova avaliação ao backend. Nunca conclui nada sozinho:
 * erro HTTP não dispara gatilho, e quem decide se a etapa está atendida é o validador do backend.
 */
export const onboardingRevalidationInterceptor: HttpInterceptorFn = (req, next) => {
  if (READ_METHODS.has(req.method) || req.url.includes('/onboarding/')) {
    return next(req);
  }
  const bus = inject(OnboardingTriggerBus);
  return next(req).pipe(
    tap((event) => {
      if (event instanceof HttpResponse && event.ok) {
        bus.notifyIfMatches(req.method, req.url);
      }
    })
  );
};
